import { useContext, useState } from 'react'

import RecoverError from './RecoverError'
import ModalRecover from './ModalRecover'
import RecoverSuccess from './RecoverSuccess'

import { AuthContext } from '../../../../contexts/auth'

function FormRecover(props) {
  const [recoverErrorActive, setRecoverErrorActive] = useState(false)
  const [recoverSuccessActive, setRecoverSuccessActive] = useState(false)
  const [recoverErrorDescription, setRecoverErrorDescription] = useState('')
  const auth = useContext(AuthContext)

  async function handleSubmitRecover(e, email) {
    e.preventDefault()
    props.setRecoverModalActive(false)
    props.setLoadingActive(true)

    try {
      await auth.emailRecover(email)
      props.setLoadingActive(false)
      setRecoverSuccessActive(true)
    } catch (error) {
      props.setLoadingActive(false)

      setRecoverErrorDescription('Desculpe, ocorreu um erro. Tente novamente mais tarde')
      setRecoverErrorActive(true)
    }
  }

  return (
    <>
      <ModalRecover
        active={props.active}
        setRecoverModalActive={props.setRecoverModalActive}
        handleSubmitRecover={handleSubmitRecover}
      />
      <RecoverSuccess active={recoverSuccessActive} onClick={() => setRecoverSuccessActive(false)} />
      <RecoverError description={recoverErrorDescription} active={recoverErrorActive} onClick={() => setRecoverErrorActive(false)} />
    </>
  )
}

export default FormRecover
